<template>
    <div style="position:relative">
        <compFormQuery v-if="type=='query'" :formdata="getWarehouse" :value="formData" :labelWidth="235"></compFormQuery>
        <compFormEdit v-else class="margin-top-15 clearfix" ref="editform" :formdata="getWarehouse" v-model="formData" :labelWidth="235"/>
        <compLog v-if="type=='query'" class="margin-15" :data="opLogList"></compLog>
        <div class="text-right padding-right-20" v-show="type!='query'">
            <vButton theme="primary" @click="submit">确定</vButton>
            <vButton class="margin-left-10" @click="cancel">取消</vButton>
        </div>
		<vLoading size="large" transfer fix :loading="loading"></vLoading>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import { HttpGetOneErpsku, HttpSaveOneErpsku } from "@/service/sfp/sfp";
import { HttpVsSkuList } from '@/service/boss/allot';
export default {
    props:['type','id'],
	components: {
        compFormQuery: () => import("@components/templates/formquery"),
        compFormEdit: () => import("@components/templates/formedit"),
		compLog: () => import("./log"),
	},
	data() {
		return {
			query: false,
			opLogList: [],
			formData: {
				channelFlag:"",
				matchStatus:1,
			},
			erpSkusList:[],
			loading:false,
		}
	},
	created() {
		this.query = this.type === "query";
		if (this.type=='query' || this.type=='edit') {
			this.getDetail()
		}
	},
	computed: {
		...mapState('boss', ['accounts',]),
		getWarehouse() {
			return [
				{
                    label: "店铺",
					key: "channelFlag",
					tag:"vInput",
                    span: 24,
                    show:this.type=='query',
					formItem:{
						style:"width:80%"
					},
                },
                {
                    label: "店铺",
					key: "channelId",
					tag:"vSelect",
                    span: 24,
                    show:this.type!='query',
					formItem:{
						style:"width:80%"
					},
                    options:this.accounts.map(function(item){
						return {
                            value: item.id,
                            label: item.title
                        }
					}),
					props:{
                        filterable:true,
                    }
				},
				{
					label: "Seller SKU",
					tag:"vInput",
					span:24,
					key: "sellerSku",
					formItem:{
						style:"width:80%"
					},
				},
				{
					label: "Seller SKU数量",
					tag:"vInputNumber",
					key: "quantity",
                    span:24,
                    props: {
                        min: 1
                    },
                    formItem:{
						style:"width:80%"
					},
				},
				{
                    label: "ERP SKU",
					key: "erpSku",
					tag:'vSelect',
					span: 24,
					on:{
						'on-search':(val)=>{
							this.remoteMethod(val)
						}
					},
					options:this.erpSkusList.map(item=>{
						return {
							value: item.name,
                            label: item.name
						}
					}),
                    formItem:{
						style:"width:80%"
					},
					props:{
						filterable:true,
						search:true,
                        placeholder:'请输入sku，实时查询',
						// clearable:true,
					}
				},
				
				{
                    label: "状态",
					key: "matchStatus",
					span: 24,
					tag:'vSelect',
					options: [
                        {
                            value: '1',
                            label: '有效 '
                        },
                        {
                            value: '0',
                            label: '失效'
                        },
                    ],
					formItem:{
						style:"width:80%"
					},
				},
			];
		},
	},
	methods: {
		getDetail() {
			this.loading = true;
			HttpGetOneErpsku({
				id: this.id
			}).then(
				res => {
					this.handleResponse(res.data);
				},
				err => {
					this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
				}
			).finally(res=>{
				this.loading = false
			})
		},
		handleResponse(data={}){
            this.formData = data
			this.opLogList = data.opLogs
			this.remoteMethod(data.erpSku)
		},
		remoteMethod(query){
			// console.log(query)
			HttpVsSkuList({page: 1,rows: 100,'search[CN_erpSku]':query}).then(res => {
                this.erpSkusList = res.data.content.map((item) => {
                    return { name: item.erpSku, id: item.id, title:item.nameEn }
                });
            });
		},
		async submit(){
			let bool = await this.$refs.editform.validate()
			if(!bool) return
            let data = {
                // channelFlag:this.formData.channelFlag,
                channelId:this.formData.channelId,
                sellerSku:this.formData.sellerSku,
                quantity:this.formData.quantity,
                erpSku:this.formData.erpSku,
                matchStatus:this.formData.matchStatus
			}
			this.loading = true;
            HttpSaveOneErpsku({
                id:this.id,
                orgId:global.SYSID,
                ...data
            }).then(res=>{
				this.loading = false;
                this.$VMessage.success(res.message);
                this.$emit('on-close');
				this.$emit('on-update');
            },err=>{
				this.loading = false;
                this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
            })
			
		},
		cancel(){
             this.$emit('on-close');
		}
	},
}
</script>